<!--

 * @Description: 个人中心、我的产品  产品列表组件   lyj
 * @Remarks:
 -->
<template>
  <ul class="ui-goods-list">
    <div v-show="orderNone" class="order-none">
      <img src="@/assets/image/order_none.png" alt="">
      <p>暂无购买的产品
      <p/>
    </div>
    <li class="uc-item"  v-for="(item, index) in productList" :key="index">
      <div class="uc-img-sec bShadow-10">
        <div class="uc-goods-w">
          <a :href="item.goodsUrl"  target="_blank"><img   style="width: 100%;height: auto;" :src="tImgUrl(item.image.split(',')[0])" alt="" :onerror="errImgDefault"></a>
        </div>
      </div>
      <div class="uc-info">
        <div class="p-name">{{item.name}}</div>
        <div class="sub-name">{{item.intro || ''}}</div>
      </div>
      <div class="price"><span class="uc-p-num">{{ priceDis(item) }}</span></div>

       <div style="padding-left:50px;" class="status">
          <div class="status-wrapper">首页悬浮菜单显示顺序(0不显示）
            <el-input-number v-model="item.useOrder" size="mini" @change="handleChange(item)" :min="0" :max="10" label="显示顺序"></el-input-number>
          </div>
        </div>
    </li>
  </ul>
</template>

<script>
  import API from '@/api/api'

export default {
  props: {
    productList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  computed: {
    orderNone () {
      return !`${this.productList}`
    }
  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {},
  methods: {
    opTimeCounter (item) {
      // console.log(item.id)
      if (!item) {
        return
      }

      const vm = this
      this.timeCounter(item, function () {
        vm.$emit('orderUpdate')
      }, () => {
        item.status = '1001'
        item.isApplyInvoice = -1
      })
    },
    ivShow (item) {
      return this.priceDis(item) !== '￥0.00'
    },

    handleChange (item) {
      // const url = window.location.origin
      // window.open(`${url}/orderDetail/${i.id}`)
      // this.$router.push({ path: `/orderDetail/${i.id}` })
      console.log("item:")
      console.log(item)
      const productsRlt =  API.updateMyProductsUseOrder({
        id: item.id,
        useOrder: item.useOrder
      })

      this.$router.push({
        name: 'orderDetail',
        params: {
          orderId: i.id,
          isOnTrain: i.isOnTrain
        }
      })
    },

    goOrderDetail (i) {
      // const url = window.location.origin
      // window.open(`${url}/orderDetail/${i.id}`)
      // this.$router.push({ path: `/orderDetail/${i.id}` })
      this.$router.push({
        name: 'orderDetail',
        params: {
          orderId: i.id,
          isOnTrain: i.isOnTrain
        }
      })
    },
    getStatusText (status) {
      return this.statusMap[status]
    },
    goToEvaluate (i) {
      this.$router.push({ name: 'evaluate', query: { orderId: i.id } })
      // window.open(pag.href, '_blank')
    },

    visibleUpdate (b) {
      this.showInvoice = b
      this.$emit('orderUpdate')
    },

    goToPayPage (i) {
      this.$router.push({ name: 'payQRCode', query: { orderId: i.id, orderNumber: i.orderNumber } })
    },
    createInvoice (i) {
      this.currentOrderId = i.id
      this.showInvoice = true
    },
    goInvoiceDetailPage (i) {
      window.open(i.invoiceUrl)
    },
    queryQrCode (i) {
      this.selectedOrder = i
      this.qrDialogShow = true
      // setTimeout(() => {
      //   this.selectedOrder = i
      //   var canvas = document.getElementById('qrcode')
      //   QRCode.toCanvas(canvas, `http://kentrasoft.com/js-esp-mobile/#/sweep-code?orderNumber=${i.orderNumber}`, { width: 200 }, function (error) {
      //     if (error) console.error(error)
      //   })
      // }, 300)
    },
    qrcodeDialogClose (v) {
      this.qrDialogShow = v
    }
  },
  components: {

  }
}
</script>
<style>
  img{
       width: auto;
       height: auto;
       max-width: 100%;
       max-height: 100%;
       }
</style>
<style lang="stylus" scoped>
  .ui-goods-list
    width 100%
    // margin-bottom 80px

    .order-none
      width 100%
      text-align center
      padding-top 100px

      p
        color #dddddd

    .uc-item
      width 100%
      height 100px
      border-bottom 1px solid #dddddd
      box-sizing border-box
      padding 12px
      display flex

      &:last-child
        border-bottom none

      .uc-img-sec
        flex 0 0 120px
        center()
        overflow hidden

        .uc-goods-w
          goods-img-wrapper()

          img
            goods-img-image()

      .uc-info
        width 400px
        flex 0 0 250px
        box-sizing border-box
        padding 5px 10px
        // background-color green

        .p-name
          height 20px
          max-width 230px
          ellipsis2(2)
          line-height 24px
          font-size 16px
          color #333333

        .sub-name
          color #999999
          height 45px
          overflow hidden
          font-size 12px
          max-width 230px
          // ellipsis2(2)
          white-space nowrap
          text-overflow ellipsis
          leftBottom()

      .price
        flex 0 0 120px
        // background-color yellow
        center()
        font-size 18px

      .status
        flex 0 0 280px
        position relative
        center()

        .main-txt
          // height 100%
          height auto
          color orange-color
          text-align center
        // .main-txt-1
        //   height auto
        //   font-size 12px
        //   line-height 50px
        //   color: rgba(153,153,153,1)
        .uc-sub-txt
          margin-top 10px
          text-align center
          width 100%
          color #999999
          font-size 12px

      .handler
        flex 1 1 auto

        .handler-wrapper
          height 100%
          columnCenter()
          .text-button
            color #999999
            font-size 14px
            font-weight 400
</style>
